import React, { useState } from 'react'
import "../components/Basics/style.css";
import Menu from "../components/Basics/menuAPI"
import MenuCard from '../components/Basics/MenuCard';
import Navbar from '../components/Basics/navbar';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';

const uniqueList = [...new Set
  (Menu.map((curElem) => {
    return curElem.category;
    console.log(uniqueList);
    })
  ),
  "All",
];

const Restaurant = () => {
  const [menuData, setMenuData] = useState(Menu); 
  const [menuList, setMenuList] = useState(uniqueList);

  const filterItem = (category) => {

    if (category === "All"){
      setMenuData(Menu);
      return;
    }

    const updatedList = Menu.filter((curElem) => {
      return curElem.category === category;
    });
    setMenuData(updatedList);
  };
  return (
    <>
      <Header />
      <Navbar filterItem = {filterItem} menuList={menuList}/>
       <MenuCard menuData={menuData}/>
       <Footer />
    </>
  );
}

export default Restaurant;
